import { useCallback, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

export const useFeatureExposedAnalytics = (): (({
	flagKey,
	cohort,
	touchpointId,
	growthInitiative,
	additionalAttributes,
}: {
	flagKey: string;
	cohort: string;
	touchpointId: string;
	growthInitiative?: string;
	additionalAttributes?: Record<string, any>;
}) => void) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const sentFlagKeys = useRef<string[]>([]);

	// This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
	return useCallback(
		({
			flagKey,
			cohort,
			touchpointId,
			growthInitiative,
			additionalAttributes = {},
		}: {
			flagKey: string;
			cohort: string;
			touchpointId: string;
			growthInitiative?: string;
			additionalAttributes?: Record<string, any>;
		}) => {
			const flagTouchpointKey = `${flagKey}:${touchpointId}`;
			if (sentFlagKeys.current.includes(flagTouchpointKey)) {
				return;
			}

			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					action: 'exposed',
					actionSubject: 'experiment',
					actionSubjectId: `${flagKey}-exposed`,
					source: flagKey,
					attributes: {
						cohort,
						touchpointId,
						growthInitiative,
						...additionalAttributes,
					},
				},
			}).fire();

			sentFlagKeys.current.push(flagTouchpointKey);
		},
		[createAnalyticsEvent],
	);
};
